var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pb-2"},[(_vm.heading === 'h6')?_c('h6',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.label))]):_c('label',{staticClass:"label-bold mb-0"},[_vm._v(_vm._s(_vm.label))]),_c('div',[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.value))]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }